module.exports = __webpack_public_path__ + "static/img/UFL_logo_200x40px.4b7ae54b.png";